export enum WALLET_SERVICES {
    SEND = "send",
    CARD = "card",
    AIRTIME = "airtime",
    AIRTIME_INTNL = "airtime international",
    AIRTIME_DOMESTIC = "airtime domestic",
    DEPOSIT = "deposit",
    WITHDRAW = "withdraw",
    MORE = "more",
    BILLPAYMENTS = "billpayments",
    RECEIVE = "receive",
}


// WEBPACK FOOTER //
// ./src/model/types/wallet.ts